import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterStringSearchValueObject} from './FilterStringSearchValueObject.js'

export class FilterSearchTextSearchValueObject extends ValueObject {
  #searchText

  constructor({searchText}) {
    super()
    this.#searchText = searchText
  }

  static create({searchText}) {
    return new FilterSearchTextSearchValueObject({searchText: FilterStringSearchValueObject.create(searchText)})
  }

  static createWithDefaultValue({config, searchText}) {
    const {DEFAULT_SEARCH_TEXT_SEARCH} = config.get('searchFilters')

    return new FilterSearchTextSearchValueObject({
      searchText: FilterStringSearchValueObject.create({string: searchText ?? DEFAULT_SEARCH_TEXT_SEARCH})
    })
  }

  static createQueryParams({config, searchText}) {
    const {DEFAULT_SEARCH_TEXT_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterSearchTextSearchValueObject({
      searchText: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.SEARCH_TEXT],
        value: searchText ?? DEFAULT_SEARCH_TEXT_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#searchText.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#searchText.isEmpty && {...this.#searchText.queryParam})
    }
  }

  get value() {
    return this.#searchText.value
  }

  toJSON() {
    return {
      searchText: this.#searchText.toJSON()
    }
  }
}
